import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuService } from '../menu.service';
import { CmsService } from '../cms.service';

@Component({
    selector: 'app-edit-menu',
    templateUrl: './edit-menu.component.html',
    styleUrls: ['./edit-menu.component.scss']
})
export class EditMenuComponent implements OnInit {
    @Input() currentMenu = undefined;
    @Input() menuGroup;
    @Input() parentId;
    @Input() level;
    @Output() modalAction: EventEmitter<any> = new EventEmitter<any>();

    isNew = false;

    menu = {
        parent: 0,
        level: 1,
        name: '',
        route: '',
        tile: '',
        bgColour: '',
        external: 0,
        externalURL: '',
        colspan: 4,
        menuGroup: undefined,
        signedInName: '',
        signedInRoute: ''
    };

    pages = [];
    showImageLibrary = false;
    imageLibraryType = '';

    backgroundColours = [
        { Id: '', name: 'None' },
        { Id: 'bg-grey', name: 'grey' },
        { Id: 'bg-white', name: 'White' },
        { Id: 'bg-teal', name: 'Teal' },
    ];
    cols = [
        { Id: 3, name: '1/4 page tile' },
        { Id: 4, name: '1/3 page tile' },
        { Id: 6, name: 'Half page tile' },
        { Id: 8, name: '2/3 page tile' },
        { Id: 9, name: '3/4 page tile' },
        { Id: 12, name: 'Full width' },
    ];

    constructor(
        private menuService: MenuService,
        private cmsService: CmsService,
    ) { }

    ngOnInit() {
        this.menu.menuGroup = this.menuGroup;

        this.cmsService.getAll().subscribe(data => {
            this.pages = data.data;
        })
        if (this.currentMenu) {
            this.menu = this.currentMenu;
            this.isNew = false;
        } else {
            this.menu.parent = this.parentId;
            this.menu.level = this.level;
            this.menu.menuGroup = this.menuGroup;
            this.isNew = true;
        }
    }


    save() {
        const dataToEmit = {
            completed: true,
            menu: this.menu,
        };
        if (this.isNew) {
            this.menuService.create(this.menu).subscribe(data => {
                this.modalAction.emit(dataToEmit);
            })

        } else {
            this.menuService.update(this.menu).subscribe(data => {
                this.modalAction.emit(dataToEmit);
            })

        }
    }
    cancel() {
        const dataToEmit = {
            completed: false,
        };
        this.modalAction.emit(dataToEmit);
    }

    viewImageLibrary(type) {
        this.imageLibraryType = type;
        this.showImageLibrary = true;
    }

    imageSelected(e) {
        this.menu.tile = e.URL;
        this.showImageLibrary = false;
        // this.snippetService.saveSnippet(this.snippet).subscribe(data => {
        //     this.growlerService.notification(['Page contents updated'])
        // });
    }
    imageModalAction(e) {
        this.showImageLibrary = false;
    }

}
